export const transactionTypeIds: { [key: string]: number } = {
  Deposit: 3,
  Withdrawal: 4,
  Trade: 7,
  Cancelled: 25,
};
